import React from 'react'
import { Menu,MenuProps } from 'primereact/menu'
import { MenuItem } from 'primereact/menuitem'
import { Button,ButtonProps } from 'primereact/button'

type Props =
  Omit<ButtonProps,'onClick'>
  & {
    items:MenuItem[]
    menuProps?:Omit<MenuProps,'model' | 'ref'>
  } & {
    stopPropagation?:boolean
  }

const defaults = <a,>(x:a,d:{ [k in keyof a]:a[k] }) : a => ({
  ...d,
  ...x,
})
const omit = <a,ks>(x:a,ks:(keyof a)[]) : Partial<a> => {
  const temp = { ...x }
  ks.forEach((k) => {
    delete temp[k]
  })
  return temp
}

export default React.memo((props:Props) => {
  const refMenu = React.useRef<Menu>(null)
  return <>
    <Menu ref={refMenu} model={props.items} {...props.menuProps}></Menu>
    <Button
      type="button"
      onClick={(e) => {
        if(props.stopPropagation)
        {
          console.log('menu-button - stopping propagation')
          e.stopPropagation()
          e.preventDefault()
          e.nativeEvent.stopPropagation()
          e.nativeEvent.stopImmediatePropagation()
        }
        refMenu.current?.toggle(e)
      }}
      {...defaults(omit(props,['items','menuProps','stopPropagation']),{
        'icon':'pi pi-ellipsis-v',
      })}
    />
  </>
})
